module.exports = __webpack_public_path__ + "static/media/ThankYouBanner.49de738c.png";